import React, { useContext } from 'react'

interface OrgSettingsContextType {
  isGlobalUserView: boolean
}

const OrgSettingsContext = React.createContext<OrgSettingsContextType | null>(null)
OrgSettingsContext.displayName = 'OrgSettingsContext'

interface OrgSettingsVMProps {
  children: React.ReactNode
}

export const OrgSettingsViewModel: React.FC<OrgSettingsVMProps> = ({ children }) => {
  const isGlobalUserView = true

  return (
    <OrgSettingsContext.Provider
      value={{
        isGlobalUserView,
      }}
    >
      {children}
    </OrgSettingsContext.Provider>
  )
}

export function useOrgSettingsViewModel() {
  const context = useContext(OrgSettingsContext)
  if (!context) {
    throw new Error('useOrgSettingsViewModel must be used within a OrgSettingsViewModel')
  }
  return context
}
